module.exports = __webpack_public_path__ + "img/CovidSector_Infographics_7.6203fc07.png";